import { useIntl } from 'react-intl';

import { ELogLevel } from '@services/errorService';
import { useErrorContext } from '@services/errorService';
import { isNotEmpty } from '@utils/general';

import { messages } from '../../../messages';
import { IDiscount, IProduct } from '../../../model';
import { IDiscountItemProps } from '../components';
import { DISCOUNT_TYPE_CUSTOMER_LOYALTY } from '../constants';

interface IDiscountListItem extends IDiscountItemProps {
  key: string;
}

export const useDiscountList = (
  discounts: IDiscount[] = [],
  products: IProduct[] = [],
  whiteList?: number[],
): Omit<IDiscountListItem, 'isDualPriceLayout'>[] => {
  const { formatMessage } = useIntl();
  const { callLogger } = useErrorContext();

  const isSpecialDiscount = isSpecialDiscountInCart(products);

  const applyDiscountType = (discount: IDiscount): Omit<IDiscountListItem, 'isDualPriceLayout'> | undefined => {
    if (discount.discountType === DISCOUNT_TYPE_CUSTOMER_LOYALTY) {
      // loyalty discount for regular customers
      return {
        key: `discount-${discount.discountType}`,
        text: formatMessage(messages.discountLoyaltyMessage, { percent: discount.percentValue }),
        description: isSpecialDiscount ? formatMessage(messages.discountLoyaltyDescription) : '',
        value: discount.moneyValue,
      };
    }
    // this should not happen
    callLogger({ logLevel: ELogLevel.INFORMATION, logMessage: `Unknown Discount type: ${discount.discountType}` });
  };

  const filteredDiscounts = whiteList ? discounts.filter((d) => whiteList.includes(d.discountType)) : discounts;

  return filteredDiscounts.map(applyDiscountType).filter(isNotEmpty);
};

const isSpecialDiscountInCart = (products: IProduct[]) => products.some((x) => x.discount || x.action || x.upselling);
